module.exports = __webpack_public_path__ + "static/media/cyp.504add5c.svg";